import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { dataNavbarlink } from "../../data/navlink";
import HamburgerIcon from "../../common/images-new/new-hamburger.png";
import { ReactComponent as EditProfileIcon } from "../../common/images-new/edit-profile-icon.svg";
import { ReactComponent as LogoutIcon } from "../../common/images-new/logout-icon.svg";
import Swal from "sweetalert2";
import { loadVBE, logoutUser, loadUser } from "../../redux/actions/auth";
import {
  BgBlue,
  Card,
  LiDiv,
  TextDarkBlue,
  TextGray,
  MenuItemCard,
  MenuItemDiv,
  headerDiv,
} from "../../pages/Theme";
import { tokenAuthorize } from "../Helpers/Common";
import { getUserNavigationConfrimPopup } from "../../redux/actions/commonAction";
import axios from "axios";
import { serverUrl } from "../Helpers/Config";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { makeStyles } from "@mui/styles";
import { Button } from "@mui/material";
import { getProfilePic, trimString } from "../Helpers/Common";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import COMPANY_LOGO_White from "../../common/images-new/nie-logo-white.png";
import COMPANY_LOGO from "../../common/images-new/nie-default-logo.jpg";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const Navbar = ({
  profilePhoto,
  username,
  email,
  programme_category,
  guid,
  isNavShown,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [anchorProfileEl, setAnchorProfileEl] = React.useState(null);
  const [anchorVBEEl, setAnchorVBEEl] = React.useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const userProfile = useSelector((state) => state.auth.user);
  const reflectionFeedbackProcessing = useSelector(
    (state) =>
      state.reflectionFeedbackReducer.reflectionFeedbackProcessing || false
  );
  const userNavigatingConfrimPopup = useSelector(
    (state) => state.commonData.userNavigatingConfrimPopup || false
  );
  const vbeList = useSelector((state) => state.auth.vbeLists);
  const [learnerProfile, setLearnerProfileList] = useState([]);
  const userTheme = useSelector((state) => state.auth.theme);
  const isDefaultTheme = useSelector((state) => state.auth.isDefaultTheme);
  const [vardataNavbarlink, setDataNavbarlink] = useState(dataNavbarlink);
  const location = useLocation();
  const [isVBEMenuOpen, setIsVBEMenuOpen] = useState(false);
  const [expandedMenus, setExpandedMenus] = useState({});
  const [mblsubMenuAnchor, setMblsubMenuAnchor] = useState(false);
  const [userMenuFinal, setuserMenuFinal] = useState([]);
  const user_menu_items = useSelector((state) => state.auth.menu_items);
  const useStyles = makeStyles((theme) => ({
    customMenu: {
      backgroundColor:
        isDefaultTheme == false && userTheme
          ? `${userTheme?.color3} !important`
          : "white !important",
      width: "250px !important;",
    },
  }));
  useEffect(() => {
  }, [userTheme]);

  const classes = useStyles();
  const toggleMenu = (menuId) => {
    setExpandedMenus((prev) => ({
      [menuId]: !prev[menuId] || false, // open if closed, or close if already open
    }));
  };

  const getUserMenu = () => {
    const role = userProfile && userProfile.role ? userProfile.role : "MEMBER";
    switch (role) {
      case "MANAGER":
        return vardataNavbarlink;
      case "MEMBER":
      default:
        return vardataNavbarlink.filter((menuItem) => menuItem.member === true);
    }
  };

  const userMenu = getUserMenu();

  // useEffect(() => {
  //     const getData = async () => {
  //         dispatch(loadVBE(userProfile?.guid));
  //         await axios.get(
  //             serverUrl.GetMenus2 + '/' + guid
  //         ).then(resp => {
  //             if (resp.status === 200) {
  //                 let data = [];
  //                 resp?.data && resp?.data?.map((r) => (
  //                     userMenu.map((s) => (
  //                         ((s.title?.toLowerCase() === "my showcase" && r.menu_name.toLowerCase() === "my showcase")) ? data.push(s) : "",
  //                         (r.menu_name?.toLowerCase() === s.title?.toLowerCase() && r.menu_name?.toLowerCase() != "my showcase") ? data.push(s) : ""
  //                     ))
  //                 ));
  //                 setuserMenuFinal(data);
  //             }
  //         })
  //             .catch(err => {
  //                 tokenAuthorize(err?.response?.status);
  //                 console.log(err)
  //             })
  //     }
  //     getData();
  // }, [])
  useEffect(() => {
    dispatch(loadVBE(userProfile?.guid));
    let data = [];
    user_menu_items &&
      user_menu_items?.map((r) =>
        userMenu.map(
          (s) => (
            s.title?.toLowerCase() === "my showcase" &&
            r.menu_name.toLowerCase() === "my showcase"
              ? data.push(s)
              : "",
            r.menu_name?.toLowerCase() === s.title?.toLowerCase() &&
            r.menu_name?.toLowerCase() != "my showcase"
              ? data.push(s)
              : ""
          )
        )
      );
    setuserMenuFinal(data);
  }, [user_menu_items]);

  useEffect(() => {}, [userNavigatingConfrimPopup]);

  //Learner Profile
  useEffect(() => {
    if (userProfile?.user_id) {
      axios
        .get(serverUrl.LearnerProfiles + userProfile?.user_id)
        .then((resp) => {
          if (resp.status === 200) {
            setLearnerProfileList(resp?.data?.results);
          }
        })
        .catch((err) => {
          tokenAuthorize(err?.response?.status);
        });
    }
  }, []);

  const handleLogout = () => {
    dispatch(logoutUser());
  };

  useEffect(() => {
    setInterval(() => {
      if (localStorage.getItem("idleTime") == "true") {
        localStorage.removeItem("idleTime");
        localStorage.setItem('autoLogout', 'idle');
        handleLogout();
      }
    }, 1000);
  }, []);

  const handleProfileClick = (event) => {
    let target = event.currentTarget;
    if (userNavigatingConfrimPopup) {
      Swal.fire({
        heightAuto: false,
        title: "Changes not saved",
        text: "Are you sure to leave this page?",
        icon: "warning",
        showCancelButton: false,
        showDenyButton: true,
        confirmButtonText: "Confirm",
        denyButtonText: "Cancel",
        confirmButtonColor: "#3085d6",
        denyButtonColor: "#c1c1c1",
      }).then((result) => {
        if (result.isConfirmed) {
          setAnchorProfileEl(target);
          dispatch(getUserNavigationConfrimPopup(false));
        }
      });
    } else {
      setAnchorProfileEl(event.currentTarget);
    }
  };

  const handleProfileClose = () => {
    setAnchorProfileEl(null);
  };

  const handleNaigate = (url) => {
    if (userNavigatingConfrimPopup) {
      Swal.fire({
        heightAuto: false,
        title: "Changes not saved",
        text: "Are you sure to leave this page?",
        icon: "warning",
        showCancelButton: false,
        showDenyButton: true,
        confirmButtonText: "Confirm",
        denyButtonText: "Cancel",
        confirmButtonColor: "#3085d6",
        denyButtonColor: "#c1c1c1",
      }).then((result) => {
        if (result.isConfirmed) {
          sessionStorage.removeItem("profilePath");
          sessionStorage.removeItem("profileCurrentPath");
          dispatch(getUserNavigationConfrimPopup(false));
          history.push(url);
        }
      });
    } else {
      history.push(url);
      sessionStorage.removeItem("profilePath");
      sessionStorage.removeItem("profileCurrentPath");
    }
  };

  //Switch Learner Profile
  const handleSwitchProfile = (profile_id) => {
    if (userNavigatingConfrimPopup) {
      Swal.fire({
        heightAuto: false,
        title: "Changes not saved",
        text: "Are you sure to leave this page?",
        icon: "warning",
        showCancelButton: false,
        showDenyButton: true,
        confirmButtonText: "Confirm",
        denyButtonText: "Cancel",
        confirmButtonColor: "#3085d6",
        denyButtonColor: "#c1c1c1",
      }).then((result) => {
        if (result.isConfirmed) {
          let data = {
            user_id: userProfile?.user_id,
            profile_id: profile_id,
          };
          axios
            .post(serverUrl.SwitchProfile, data)
            .then((resp) => {
              if (resp.status === 200) {
                dispatch(loadUser());
                window.location.href = "/";
              }
            })
            .catch((err) => {
              tokenAuthorize(err?.response?.status);
            });
        }
      });
    } else {
      let data = {
        user_id: userProfile?.user_id,
        profile_id: profile_id,
      };
      axios
        .post(serverUrl.SwitchProfile, data)
        .then((resp) => {
          if (resp.status === 200) {
            dispatch(loadUser());
            window.location.href = "/";
          }
        })
        .catch((err) => {
          tokenAuthorize(err?.response?.status);
        });
    }
  };

  const handleVBEClick = (event) => {
    let target = event.currentTarget;
    if (userNavigatingConfrimPopup) {
      Swal.fire({
        heightAuto: false,
        title: "Changes not saved",
        text: "Are you sure to leave this page?",
        icon: "warning",
        showCancelButton: false,
        showDenyButton: true,
        confirmButtonText: "Confirm",
        denyButtonText: "Cancel",
        confirmButtonColor: "#3085d6",
        denyButtonColor: "#c1c1c1",
      }).then((result) => {
        if (result.isConfirmed) {
          setAnchorVBEEl(target);
          dispatch(getUserNavigationConfrimPopup(true));
        }
      });
    } else {
      setAnchorVBEEl(event.currentTarget);
    }
  };
  const handleVBEMobileClick = () => {
    if (userNavigatingConfrimPopup) {
      Swal.fire({
        heightAuto: false,
        title: "Changes not saved",
        text: "Are you sure to leave this page?",
        icon: "warning",
        showCancelButton: false,
        showDenyButton: true,
        confirmButtonText: "Confirm",
        denyButtonText: "Cancel",
        confirmButtonColor: "#3085d6",
        denyButtonColor: "#c1c1c1",
      }).then((result) => {
        if (result.isConfirmed) {
          setIsVBEMenuOpen(!isVBEMenuOpen);
          dispatch(getUserNavigationConfrimPopup(false));
        }
      });
    } else {
      setIsVBEMenuOpen(!isVBEMenuOpen);
    }
  };
  const handleVBEClose = () => {
    setAnchorVBEEl(null);
  };
  const handleMblLearnerProfile = () => {
    if (userNavigatingConfrimPopup) {
      Swal.fire({
        heightAuto: false,
        title: "Changes not saved",
        text: "Are you sure to leave this page?",
        icon: "warning",
        showCancelButton: false,
        showDenyButton: true,
        confirmButtonText: "Confirm",
        denyButtonText: "Cancel",
        confirmButtonColor: "#3085d6",
        denyButtonColor: "#c1c1c1",
      }).then((result) => {
        if (result.isConfirmed) {
          setMblsubMenuAnchor(!mblsubMenuAnchor);
          dispatch(getUserNavigationConfrimPopup(false));
        }
      });
    } else {
      setMblsubMenuAnchor(!mblsubMenuAnchor);
    }
  };
  return (
    <nav className="shadow-lg xl:px-8 px-4 py-4 w-full flex items-center justify-between navBar">
      {/* Left Section: Logos */}
      <div className="flex items-center space-x-4">
        <img
          src={
            userTheme == "default theme" || userTheme == ""
              ? COMPANY_LOGO
              : COMPANY_LOGO_White
          }
          alt="NIE"
          className={`${
            !reflectionFeedbackProcessing ? "cursor-pointer" : "cursordisabled"
          } logoNIEIcon`}
          onClick={() => handleNaigate("/")}
        />
      </div>
      {isNavShown && (
        <>
          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-4 gap-2 xl:gap-4">
            {userMenuFinal.map((item, index) => {
              const Icon = item.icon; // either imported SVG or MUI icon
              return (
                <div
                  key={index}
                  // href={item.title != "VBE" && item.url}
                  className={`flex items-center space-x-1 text-sm hover:no-underline navItem ${
                    !reflectionFeedbackProcessing
                      ? "cursor-pointer"
                      : "cursordisabled"
                  } font-medium ${
                    location.pathname.split("/").filter(Boolean)[0] ==
                      item.url.split("/").filter(Boolean)[0] &&
                    item.title !== "VBE"
                      ? "navBarActive"
                      : "navBarInActive"
                  }`}
                  aria-controls={item.title === "VBE" ? "VBE-menu" : ""}
                  aria-haspopup={item.title === "VBE" ? "true" : ""}
                  // onClick={item.title === "VBE" ? handleVBEClick : handleNaigate}
                  onClick={(e) => {
                    item.title === "VBE"
                      ? handleVBEClick(e)
                      : handleNaigate(item.url);
                  }}
                >
                  {location.pathname.split("/").filter(Boolean)[0] ==
                    item.url.split("/").filter(Boolean)[0] &&
                  item.title !== "VBE" ? (
                    <Icon className="fillActive" />
                  ) : (
                    <Icon className="fillInActive" />
                  )}
                  {/* <img src={item.icon} alt={item.title} className={`${location.pathname.split('/').filter(Boolean)[0] == item.url.split('/').filter(Boolean)[0] ? 'blueColor' : 'blackColor'}`} /> */}
                  <span
                    className={`${
                      item.title !== "VBE" &&
                      location.pathname.split("/").filter(Boolean)[0] ==
                        item.url.split("/").filter(Boolean)[0]
                        ? "navBarActive"
                        : "navBarInActive"
                    } whitespace-nowrap`}
                  >
                    {item.title}
                  </span>
                </div>
              );
            })}
            {/* VBE Menu */}
            <div>
              <MenuItemCard key="VBE-menu">
                <Menu
                  id="VBE-menu"
                  anchorEl={anchorVBEEl}
                  keepMounted
                  open={Boolean(anchorVBEEl)}
                  onClose={handleVBEClose}
                  classes={{ paper: classes.customMenu }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  disableScrollLock={true}
                >
                  {/* Dynamically render parent and submenu */}
                  {vbeList?.message?.map((menu) => (
                    <MenuItemCard key={menu.menu_id}>
                      <MenuItem className="pointer-events-none">
                        <MenuItemDiv className="font-bold blackColor text-base">
                          {menu.menu_name}
                        </MenuItemDiv>
                      </MenuItem>
                      {menu?.sub_menus?.length > 0 &&
                        menu?.sub_menus.map((sub) => (
                          <MenuItem
                            key={sub.menu_id}
                            component="a"
                            href={sub.menu_url || "#"}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <MenuItemDiv className="text-sm lightColor">
                              {sub.menu_name}
                            </MenuItemDiv>
                          </MenuItem>
                        ))}
                    </MenuItemCard>
                  ))}
                </Menu>
              </MenuItemCard>
            </div>
          </div>

          {/* Right Section: Icons */}
          <div className="hidden lg:flex items-center space-x-4">
            <img
              src={profilePhoto}
              alt="Profile"
              className={`w-10 h-10 rounded-full border-2 ${
                !reflectionFeedbackProcessing
                  ? "cursor-pointer"
                  : "cursordisabled"
              }`}
              aria-controls="profile-menu"
              aria-haspopup="true"
              onClick={handleProfileClick}
            />
            {/* Profile Menu */}
            <div>
              <MenuItemCard
                key={"profile-menu"}
                sx={{
                  paddingTop: "0px !important",
                  paddingBottom: "0px !important",
                }}
              >
                <Menu
                  id="profile-menu"
                  anchorEl={anchorProfileEl}
                  keepMounted
                  open={Boolean(anchorProfileEl)}
                  onClose={handleProfileClose}
                  classes={{ paper: classes.customMenu }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  disableScrollLock={true}
                  sx={{
                    paddingTop: "0px !important",
                    paddingBottom: "0px !important",
                  }}
                >
                  <MenuItemCard
                    key={"profile-menu-item"}
                    className="p-1.5 px-3"
                  >
                    {/* Profile Info Section */}
                    <div className="p-2 flex flex-col items-center text-center shadow-sm bg-gray rounded-lg mb-3.5">
                      <img
                        src={profilePhoto}
                        alt="Profile"
                        className="w-14 h-14 rounded-full border mb-2 object-cover"
                      />
                      <p className="font-semibold text-base blackColor">
                        {username}
                      </p>
                      <p
                        className="lightColor text-xs mt-1"
                        title={programme_category}
                      >
                        {programme_category
                          ? trimString(programme_category, 30)
                          : ""}
                      </p>
                    </div>
                    <hr className="" />
                    {learnerProfile.length > 1 && (
                      <>
                        <div className="border-b pb-1 mb-1 px-1">
                          <p className="text-sm blackColor font-semibold pt-2 px-2">
                            Learner Profiles
                          </p>
                          {learnerProfile?.length &&
                            learnerProfile.map((i) => (
                              <MenuItem
                                title={i.name}
                                className="flex gap-1.5 switchProfile  text-sm blackColor"
                                onClick={() => {
                                  handleSwitchProfile(i.profile_id);
                                }}
                              >
                                <img
                                  src={getProfilePic(i.photo)}
                                  title={i.name}
                                  alt="pics"
                                  className="rounded-full w-6 h-6 object-cover"
                                />
                                <p className="whitespace-normal text-xs break-words blackColor">
                                  {i.name}
                                </p>
                                {i.is_active && (
                                  <CheckCircleIcon className="primaryIcon" />
                                )}
                              </MenuItem>
                            ))}
                        </div>
                      </>
                    )}
                    <MenuItem
                      className="pt-2"
                      onClick={() => handleNaigate("/account-settings")}
                    >
                      <MenuItemDiv className="blackColor text-sm flex items-center gap-1">
                        <EditProfileIcon className="mr-2 fillActivePrimary w-4 h-4" /> Edit
                        Profile
                      </MenuItemDiv>
                    </MenuItem>
                    <MenuItem onClick={handleLogout}>
                      <MenuItemDiv className="blackColor text-sm flex items-center gap-1">
                        <LogoutIcon className="mr-2 w-4 h-4 fillActivePrimary" /> Sign Out
                      </MenuItemDiv>
                    </MenuItem>
                  </MenuItemCard>
                </Menu>
              </MenuItemCard>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className={`${
                !reflectionFeedbackProcessing
                  ? "cursor-pointer"
                  : "cursordisabled"
              }`}
            >
              <img src={HamburgerIcon} alt="Menu" className="" />
            </button>
          </div>

          {/* Mobile Menu */}
          {menuOpen && (
            <div className="absolute left-0 right-0 border-t border-b border-gray-200 p-4 lg:hidden z-50 mblNavBar overflow-y-auto">
              {userMenuFinal.map((item, index) => {
                const Icon = item.icon;
                return (
                  <>
                    <div
                      key={index}
                      // href={item.title != "VBE" && item.url}
                      className={`flex items-center space-x-3 py-2 text-sm hover:no-underline ${
                        !reflectionFeedbackProcessing
                          ? "cursor-pointer"
                          : "cursordisabled"
                      } font-medium ${
                        location.pathname.split("/").filter(Boolean)[0] ==
                          item.url.split("/").filter(Boolean)[0] &&
                        item.title !== "VBE"
                          ? "navBarActive"
                          : "navBarInActive"
                      }`}
                      aria-controls={item.title === "VBE" ? "VBE-menu" : ""}
                      aria-haspopup={item.title === "VBE" ? "true" : ""}
                      onClick={(e) => {
                        item.title === "VBE"
                          ? handleVBEMobileClick()
                          : handleNaigate(item.url);
                      }}
                    >
                      {location.pathname.split("/").filter(Boolean)[0] ==
                        item.url.split("/").filter(Boolean)[0] &&
                      item.title !== "VBE" ? (
                        <Icon className="fillActive" />
                      ) : (
                        <Icon className="fillInActive" />
                      )}
                      <span
                        className={`${
                          item.title !== "VBE" &&
                          location.pathname.split("/").filter(Boolean)[0] ==
                            item.url.split("/").filter(Boolean)[0]
                            ? "navBarActive"
                            : "navBarInActive"
                        } whitespace-nowrap`}
                      >
                        {item.title}
                      </span>
                      {item.title === "VBE" &&
                        (isVBEMenuOpen ? (
                          <ExpandLessIcon className="navBarInActive" />
                        ) : (
                          <ExpandMoreIcon className="navBarInActive" />
                        ))}
                    </div>
                    {/* Show VBE Submenus */}
                    {item.title === "VBE" && isVBEMenuOpen && (
                      <div className="pl-4 pt-1">
                        {vbeList?.message?.map((menu) => (
                          <div key={menu.menu_id} className="mb-2">
                            <div
                              onClick={() => toggleMenu(menu.menu_id)}
                              className="flex justify-between items-center px-2 py-1 cursor-pointer"
                            >
                              <div className="font-bold text-sm navBarInActive">
                                {menu.menu_name}
                              </div>
                              {menu?.sub_menus?.length > 0 &&
                                (expandedMenus[menu.menu_id] ? (
                                  <ExpandLessIcon className="navBarInActive" />
                                ) : (
                                  <ExpandMoreIcon className="navBarInActive" />
                                ))}
                            </div>

                            {/* Submenus */}
                            {expandedMenus[menu.menu_id] &&
                              menu?.sub_menus?.length > 0 && (
                                <div className="pl-4 py-1 space-y-1">
                                  {menu.sub_menus.map((sub) => (
                                    <div key={sub.menu_id}>
                                      <a
                                        href={sub.menu_url || "#"}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="block text-sm navBarInActive"
                                      >
                                        {sub.menu_name}
                                      </a>
                                    </div>
                                  ))}
                                </div>
                              )}
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                );
              })}
              <div className="pb-2">
                <div
                  className={`flex items-center mr-5 py-2 ${
                    !reflectionFeedbackProcessing
                      ? "cursor-pointer"
                      : "cursordisabled"
                  }`}
                  onClick={() => handleNaigate("/account-settings")}
                >
                  <EditProfileIcon className="fillInActive mr-2 w-5 h-5" />
                  <p className="text-sm navBarInActive">Edit Profile</p>
                </div>
                {/* Learner Profile */}
                {learnerProfile.length > 1 && (
                  <>
                    <div
                      className={`${
                        !reflectionFeedbackProcessing
                          ? "cursor-pointer"
                          : "cursordisabled"
                      } flex items-center py-2`}
                      onClick={() => handleMblLearnerProfile()}
                    >
                      <EditProfileIcon className="fillInActive mr-2 w-5 h-5" />
                      <p className="text-sm navBarInActive">Learner Profiles</p>
                      {mblsubMenuAnchor ? (
                        <ExpandLessIcon className="pt-0.5 navBarInActive" />
                      ) : (
                        <ExpandMoreIcon className="pt-0.5 navBarInActive" />
                      )}
                    </div>
                    <div
                      className="px-5"
                      id="basic-button"
                      style={{ display: !mblsubMenuAnchor && "none" }}
                    >
                      {learnerProfile?.length > 1 &&
                        learnerProfile.map((i, ind) => (
                          <>
                            <div
                              className="flex py-2 gap-2 cursor-pointer"
                              key={ind}
                              id={ind}
                              title={i.name}
                              onClick={() => {
                                handleSwitchProfile(i.profile_id);
                              }}
                            >
                              <p
                                className="font-normal flex gap-1.5 text-sm cursor-pointer items-center hover:opacity-80 navBarInActive"
                                id={ind}
                              >
                                {/* {trimString(i.name, 25)} */}
                                <img
                                  src={getProfilePic(i.photo)}
                                  title={i.name}
                                  alt="pics"
                                  className="rounded-full w-6 h-6 object-cover"
                                />
                                {i.name}
                                {i.is_active && (
                                  <CheckCircleIcon className="primaryIcon" />
                                )}
                              </p>
                            </div>
                          </>
                        ))}
                    </div>
                  </>
                )}
                <div
                  className="flex items-center mr-5 py-2"
                  onClick={handleLogout}
                >
                  {/* <img className="mr-2 fill" src={LogoutIcon} alt="icon"></img> */}
                  <LogoutIcon className="fillInActive mr-2 w-5 h-5" />
                  <p className="text-sm navBarInActive">Sign Out</p>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </nav>
  );
};

export default Navbar;
